// Holding pages, reachable and behind the login.
// - ProductHolding, in the shell's look: Profit On Your Terms and the Accelerator, whose own pages
//   are phase 2 (BUILD-PLAN stage 4; the critic's settlement, 3 Oct), keep it while they're open.
// - ProductPageHolding, inside the product's own frame: a page of a phase 1 product whose screen
//   isn't in yet (its home, or a type extra), so its header, menu and look are already there.
import { Link } from '../lib/router.jsx'
import { ShellPage, BackToLibrary } from '../shell/Shell.jsx'

export function ProductHolding({ product, kind }) {
  return (
    <ShellPage title={product.name} eyebrow={kind} heading={product.name}>
      <p className="sh-lede">This page is being built. What you have in it shows in your library for now.</p>
      <BackToLibrary />
    </ShellPage>
  )
}

export function ProductPageHolding({ product, back = false }) {
  return (
    <section className="pp-holding">
      <h1 className="pp-holding-h1">{product.name}</h1>
      <p className="pp-holding-text">This page is being built. What you have in it shows in your library for now.</p>
      <p className="pp-holding-actions">
        {back
          // the masterclass's full name runs past a 360 phone on 1 line, so "the video", as Next up's "Open the video"
          ? <Link to={product.path || '/'} className="pp-btn">Back to {product.type === 'masterclass' ? 'the video' : product.name}</Link>
          : <Link to="/" className="pp-btn">Back to your library</Link>}
      </p>
    </section>
  )
}
